import React, { useEffect, useState } from "react";
import { db } from "../../firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";
import Swal from "sweetalert2";

export default function ManageKontak() {
  const [form, setForm] = useState({
    alamat: "",
    telepon: "",
    email: "",
    instagram: "",
    youtube: "",

    mapsEmbed: "",
    mapsLat: "",
    mapsLng: "",
  });

  const [loading, setLoading] = useState(false);
  const [detecting, setDetecting] = useState(false);

  const kontakRef = doc(db, "informasi", "kontakSekolah");

  /* ================= FETCH ================= */
  useEffect(() => {
    const fetchData = async () => {
      const snap = await getDoc(kontakRef);
      if (snap.exists()) {
        setForm({
          alamat: snap.data().alamat || "",
          telepon: snap.data().telepon || "",
          email: snap.data().email || "",
          instagram: snap.data().instagram || "",
          youtube: snap.data().youtube || "",
          mapsEmbed: snap.data().mapsEmbed || "",
          mapsLat: snap.data().mapsLat || "",
          mapsLng: snap.data().mapsLng || "",
        });
      }
    };
    fetchData();
  }, []);

  /* ================= HANDLER ================= */
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "telepon") {
      const onlyNumber = value.replace(/[^0-9]/g, "");
      setForm((p) => ({ ...p, telepon: onlyNumber }));
      return;
    }

    setForm((p) => ({ ...p, [name]: value }));
  };

  /* ================= GEOLOCATION ================= */
  const handleCurrentLocation = () => {
    if (!navigator.geolocation) {
      return Swal.fire("Tidak didukung", "Browser tidak mendukung GPS", "error");
    }

    setDetecting(true);

    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const lat = pos.coords.latitude;
        const lng = pos.coords.longitude;

        const embedUrl = `https://www.google.com/maps?q=${lat},${lng}&z=16&output=embed`;

        setForm((p) => ({
          ...p,
          mapsLat: lat,
          mapsLng: lng,
          mapsEmbed: embedUrl,
        }));

        Swal.fire("Berhasil", "Lokasi saat ini berhasil diambil", "success");
        setDetecting(false);
      },
      () => {
        Swal.fire("Gagal", "Tidak bisa mengambil lokasi", "error");
        setDetecting(false);
      },
      { enableHighAccuracy: true }
    );
  };

  /* ================= SAVE ================= */
  const handleSave = async () => {
    if (!form.telepon) {
      return Swal.fire("Validasi", "Nomor telepon wajib diisi", "warning");
    }

    setLoading(true);
    try {
      await setDoc(kontakRef, form);
      Swal.fire("Berhasil!", "Kontak sekolah berhasil disimpan", "success");
    } catch {
      Swal.fire("Error!", "Gagal menyimpan data kontak", "error");
    }
    setLoading(false);
  };

  /* ================= UI ================= */
  return (
    <div className="container mt-4">
      <h2>Kelola Kontak Sekolah</h2>

      <div className="card p-4 shadow-sm">

        <div className="mb-3">
          <label>Alamat Sekolah</label>
          <textarea
            className="form-control"
            name="alamat"
            rows="3"
            value={form.alamat}
            onChange={handleChange}
          />
        </div>

        <div className="row">
          <div className="col-md-6 mb-3">
            <label>Nomor Telepon</label>
            <input
              className="form-control"
              name="telepon"
              value={form.telepon}
              onChange={handleChange}
              inputMode="numeric"
              placeholder="Contoh: 08123456789"
            />
            <small className="text-muted">* Hanya angka</small>
          </div>

          <div className="col-md-6 mb-3">
            <label>Email Sekolah</label>
            <input
              type="email"
              className="form-control"
              name="email"
              value={form.email}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="mb-3">
          <label>Instagram</label>
          <input
            className="form-control"
            name="instagram"
            value={form.instagram}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>YouTube</label>
          <input
            className="form-control"
            name="youtube"
            value={form.youtube}
            onChange={handleChange}
          />
        </div>

        <hr />

        {/* ================= GOOGLE MAPS ================= */}
        <h5>Lokasi Sekolah (Google Maps)</h5>

        <button
          className="btn btn-outline-primary mb-3"
          onClick={handleCurrentLocation}
          disabled={detecting}
        >
          📍 {detecting ? "Mengambil Lokasi..." : "Gunakan Lokasi Saat Ini"}
        </button>

        <div className="mb-3">
          <label>
            Google Maps (Opsional)
            <small className="text-muted d-block">
              Bisa isi link Google Maps atau iframe embed
            </small>
          </label>
          <textarea
            className="form-control"
            name="mapsEmbed"
            rows="3"
            value={form.mapsEmbed}
            onChange={handleChange}
            placeholder="Tempel link Google Maps atau iframe embed"
          />
        </div>

        {(form.mapsEmbed || (form.mapsLat && form.mapsLng)) && (
          <div className="mb-3">
            <label className="fw-bold">Preview Maps</label>
            <div className="ratio ratio-16x9 border rounded">

              {/* JIKA IFRAME */}
              {form.mapsEmbed?.includes("<iframe") ? (
                <div
                  dangerouslySetInnerHTML={{ __html: form.mapsEmbed }}
                  style={{ width: "100%", height: "100%" }}
                />
              ) : (
                <iframe
                  src={
                    form.mapsEmbed
                      ? form.mapsEmbed
                      : `https://www.google.com/maps?q=${form.mapsLat},${form.mapsLng}&z=16&output=embed`
                  }
                  title="Google Maps"
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  style={{ border: 0 }}
                />
              )}

            </div>
          </div>
        )}

        <button
          className="btn btn-primary"
          onClick={handleSave}
          disabled={loading}
        >
          {loading ? "Menyimpan..." : "Simpan Kontak"}
        </button>
      </div>
    </div>
  );
}
